import * as React from 'react';
import { Snackbar, Slide } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
        '& li': {
            marginLeft: -10
        }
    },
}));
function SlideTransition(props) {
    return React.createElement(Slide, Object.assign({}, props, { direction: "up" }));
}
export const ErrorHandler = props => {
    const errorMessages = (responseCode) => {
        switch (responseCode) {
            case 403: return {
                title: "Du har ikke tilladelse",
                body: React.createElement("span", null,
                    "Du har ikke tilladelse til denne del af hjemmesiden.",
                    React.createElement("br", null),
                    "Kontakt Badminton Danmark hvis du mener at dette er en fejl.")
            };
            case 404: return {
                title: props.errorTitle404 || "Kunne ikke findes",
                body: props.errorBody404 || React.createElement("span", null,
                    "Du har ikke tilladelse til denne del af hjemmesiden.",
                    React.createElement("br", null),
                    "Kontakt Badminton Danmark hvis du mener at dette er en fejl.")
            };
            case 500: return {
                title: "Der opstod en systemfejl",
                body: React.createElement("span", null,
                    "Der opstod en serverfejl i behandlingen af din anmodning. Pr\u00F8v igen p\u00E5 et senere tidspunkt eller,",
                    React.createElement("br", null),
                    "kontakt Badminton Danmark hvis problemet bliver ved med at opst\u00E5.")
            };
            default: return {
                title: "Der opstod en fejl",
                body: React.createElement("span", null,
                    "Der opstod en ukendt fejl.",
                    React.createElement("br", null),
                    "Kontakt Badminton Danmark hvis fejlen forts\u00E6tter.")
            };
        }
    };
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.appError !== null || props.systemErrors.length > 0);
    // Tag højde for både objekt og array typer for error
    const isSystemError = props.systemErrors && props.systemErrors.length > 0, autoHideDuration = isSystemError ? null : 6000, errorType = isSystemError ? (props.systemErrors[0].status ? props.systemErrors[0].status : 0) : 0, defaultErrorTitle = "Der opstod en fejl", title = isSystemError ? errorMessages(errorType).title : defaultErrorTitle;
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(Snackbar, { open: open, autoHideDuration: autoHideDuration, onClose: handleClose, TransitionComponent: SlideTransition, anchorOrigin: { vertical: 'top', horizontal: 'center' } },
            React.createElement(Alert, { elevation: 6, variant: "filled", onClose: handleClose, severity: "error" },
                React.createElement(AlertTitle, null, title),
                isSystemError && props.systemErrors.length > 0 &&
                    React.createElement("ul", { style: { color: '#fff' } }, props.systemErrors.map((error, idx) => React.createElement("li", { key: "sysError" + idx }, errorMessages(errorType).body))),
                !isSystemError && props.appError &&
                    React.createElement("ul", { style: { color: '#fff' } }, props.appError.status === 500
                        ? props.appError['message']
                        : Object.keys(props.appError).map((errorKey, keyIdx) => Array.isArray(props.appError[errorKey]) && props.appError[errorKey].length > 0
                            ? props.appError[errorKey].map((error, idx) => React.createElement("li", { key: "error" + keyIdx + "" + idx }, error))
                            : React.createElement("li", { key: "error" + keyIdx }, props.appError[errorKey][0])))))));
};
